import React from "react";

import "./styles.scss"
import UnSubscribeUI from "../../../assets/component/page-errors/un-subscribe";

const ChatInsightsMain = ({ model }) => {
    return (
        <div className="chat-insights-main">
            <UnSubscribeUI />
        </div>
    )
}

export default ChatInsightsMain